export default __webpack_public_path__ + "static/Welcome Church Logo-d78b493882f1d6bc115d7a7d6d14d2c8.jpeg";